var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill2: "#8A8F98",
    className: "sc-qQvjG bcMvhN",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7191 2H2.17335C1.50213 2 0.958008 2.59695 0.958008 3.33333V5.33333C0.958008 5.70152 1.23007 6 1.56568 6H14.3268C14.6624 6 14.9344 5.70152 14.9344 5.33333V3.33333C14.9344 2.59695 14.3903 2 13.7191 2C13.7191 2 13.7191 2 13.7191 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2689 7H2.62355C2.25598 7 1.95801 7.27252 1.95801 7.6087V12.7826C1.95801 13.455 2.55396 14 3.2891 14H12.6033C13.3385 14 13.9344 13.455 13.9344 12.7826V7.6087C13.9344 7.27252 13.6365 7 13.2689 7ZM10.1092 9.13043C10.1085 9.55037 9.73648 9.89063 9.27732 9.89131H6.61513C6.15567 9.89131 5.7832 9.55065 5.7832 9.13044C5.7832 8.71022 6.15567 8.36957 6.61513 8.36957H9.27731C9.73647 8.37024 10.1085 8.7105 10.1092 9.13043Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.314820e9.svg";
export { ForwardRef as ReactComponent };